import Vue from 'vue'
import Vuex from 'vuex'
// import i18n from './modules/i18n'
import avatar from './modules/avatar'
import game from './modules/game'
import card from './modules/card'
import user from './modules/user'
import cardType from './modules/card_type'
import cardLevel from './modules/card_level'
import notification from './modules/notification'
import nav from './modules/nav'
import gameGroup from './modules/game_group'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: [
    avatar,
    game,
    card,
    user,
    cardType,
    cardLevel,
    notification,
    nav,
    gameGroup
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js